"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var AvatarBase = function (_a) {
    var profile = _a.profile, _b = _a.fallbackUrl, fallbackUrl = _b === void 0 ? '/tool-placeholder.svg' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return ((0, jsx_runtime_1.jsx)("img", { alt: (profile === null || profile === void 0 ? void 0 : profile.name) ? "".concat(profile === null || profile === void 0 ? void 0 : profile.name, "'s Logo") : 'Logo', src: (profile === null || profile === void 0 ? void 0 : profile.logoUrl) || fallbackUrl, className: className }));
};
exports.default = AvatarBase;
